import * as React from 'react';

interface State {
  isMouseOver: boolean;
  isFocused: boolean;
}

interface Props extends React.HTMLProps<HTMLAnchorElement> {
  styleNormal?: React.CSSProperties;
  styleOver?: React.CSSProperties;
  styleFocused?: React.CSSProperties;
}

export default class Link extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isMouseOver: false,
      isFocused: false
    }
  }

  render() {
    const { isFocused, isMouseOver } = this.state;
    const {
      styleNormal,
      styleFocused,
      styleOver
    } = this.props;
    let style = styleNormal;
    if (isMouseOver && styleOver) {
      style = styleOver;
    }
    if (isFocused && styleFocused) {
      style = styleFocused;
    }
    const aProps = { ...this.props };
    delete (aProps.styleFocused)
    delete (aProps.styleOver)
    delete (aProps.styleNormal)
    return (
      <a
        {...aProps}
        style={style}
        onClick={this.onLinkClick}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      />
    );
  }

  onLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const element = event.currentTarget;
    history.pushState({}, undefined, element.href);
    const { onClick } = this.props;
    if (onClick) {
      onClick(event);
    }
    window.dispatchEvent(new Event('popstate'));
  }

  onMouseOver = (event: React.MouseEvent<HTMLAnchorElement>) => {
    this.setState({ isMouseOver: true })
    const { onMouseOver } = this.props;
    if (onMouseOver) {
      onMouseOver(event);
    }
  }

  onMouseOut = (event: React.MouseEvent<HTMLAnchorElement>) => {
    this.setState({ isMouseOver: false })
    const { onMouseOut } = this.props;
    if (onMouseOut) {
      onMouseOut(event);
    }
  }

  onFocus = (event: React.FocusEvent<HTMLAnchorElement>) => {
    this.setState({ isFocused: true })
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus(event);
    }
  }

  onBlur = (event: React.FocusEvent<HTMLAnchorElement>) => {
    this.setState({ isFocused: false })
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur(event);
    }
  }
};





// WEBPACK FOOTER //
// ./src/router/Link.tsx